import { render, staticRenderFns } from "./LatestCompletedSessionCellRenderer.vue?vue&type=template&id=1b5c0a7b"
import script from "./LatestCompletedSessionCellRenderer.vue?vue&type=script&lang=js"
export * from "./LatestCompletedSessionCellRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports